import { clsx } from 'clsx'
import { type FC } from 'react'

import { useDeviceDetectorContext } from '../../../device-detector'
import { ExperimentFreeGiftPromotion } from '../../../experiments/components/ExperimentFreeGiftPromotion/ExperimentFreeGiftPromotion'
import { useIsfreeGiftPromotionsExperimentEnabledAndV2 } from '../../../experiments/components/ExperimentFreeGiftPromotion/useGetFreeGiftPromotionsExperiment'
import { useRemovePacksizesExperimentActivation } from '../../../experiments/remove-variants-for-expa-experiment/useRemovePacksizesExperimentActivation'
import { useRemovePacksizesExperimentShouldHideVariants } from '../../../experiments/remove-variants-for-expa-experiment/useRemoveVariantsExperimentShouldHideVariantsForExpa'
import { ProductPageAttributesSelection } from '../ProductPageAttributesSelection'
import { ProductPageContactLensesInfoNotification } from '../ProductPageContactLensesInfoNotification/ProductPageContactLensesInfoNotification'
import { useProductPageContext } from '../productPageContext'

import { ProductAddToCartGroup } from './ProductAddToCartGroup'
import { ProductBuyBoxStockStatusAndDeliveryInfo } from './ProductBuyBoxStockStatusAndDeliveryInfo'
import {
  ProductPageMobileRadioStyleAttributesSelection,
  ProductPageSingleAttributesHeader,
  ProductPageSingleAttributesHeaderLabels,
} from './ProductPageSingleAttributes'
import { ProductVariantHeader } from './ProductVariantHeader'
import { useProductPageShouldHidePackSizeSelectorForExpa } from './useProductPageShouldHidePackSizeSelectorForExpa'

export const ProductBuyBoxRebrushed: FC = () => {
  const { attributeSelectionControls } = useProductPageContext()
  const { hasSingleRenderGroup } = attributeSelectionControls
  const { isMobile } = useDeviceDetectorContext()
  const isFreeGiftPromotionsExperimentEnabledAndV2 =
    useIsfreeGiftPromotionsExperimentEnabledAndV2(isMobile)
  const shouldHidePackSizeSelectorForExpa =
    useProductPageShouldHidePackSizeSelectorForExpa()
  useRemovePacksizesExperimentActivation()
  const shouldHideVariantsForRemovePackSizeExperiment =
    useRemovePacksizesExperimentShouldHideVariants()

  return (
    <div
      className={clsx(
        'mb-5 w-full',
        hasSingleRenderGroup && 'rounded-2xl bg-light-primary-medium',
      )}
    >
      {hasSingleRenderGroup ? (
        <ProductPageSingleAttributesHeaderLabels />
      ) : null}
      <div
        className={clsx(
          'w-full rounded-2xl bg-light-primary-medium px-4 pb-2.5',
          hasSingleRenderGroup && 'pt-2.5',
          !hasSingleRenderGroup && 'pt-5',
        )}
      >
        {hasSingleRenderGroup ? null : <ProductVariantHeader />}
        {hasSingleRenderGroup ? <ProductPageSingleAttributesHeader /> : null}
        {hasSingleRenderGroup ? null : <ProductPageAttributesSelection />}
        <ProductBuyBoxStockStatusAndDeliveryInfo />
        <ProductAddToCartGroup />
        <ProductPageContactLensesInfoNotification />
        {/* on mobile case single we do not show "normal" attribute selection but "old school one" */}
        {hasSingleRenderGroup &&
        !shouldHidePackSizeSelectorForExpa &&
        !shouldHideVariantsForRemovePackSizeExperiment ? (
          <ProductPageMobileRadioStyleAttributesSelection />
        ) : null}
        {isFreeGiftPromotionsExperimentEnabledAndV2 ? (
          <ExperimentFreeGiftPromotion isMobile={isMobile} />
        ) : null}
      </div>
    </div>
  )
}
